import { request } from "../../proto/bundle";
import { getConnectionPool } from "../../core/connectionPool";
import { File } from "./File";
import { Folder } from "./Folder";
import { checkMigrate } from "../../init/sdkInit";

export class Item {
    static async getSharedItem(path: string,isTeam:boolean): Promise<File | Folder> {
        // //  prepend "shared/" to path
        // if (!path.startsWith("shared/")) {
        //     path = "shared/" + path;
        // }
         let pool = await getConnectionPool();
        const userType = isTeam ? request.TypeOfPath.TShareTeam : request.TypeOfPath.TShareUser;
        let req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            getMetaFromSharedPath: request.GetMetaFromSharedPath.create({
                path,
                typeOfPath: userType
            })
        });
        // console.log(`Getting shared item at path: ${path}`);
        // console.log("Request:", req);
        let resp = await pool.sendAndWait(req);
        checkMigrate(resp.GetMetaFromSharedPath.status)
        // console.log("Response from getMetaFromSharedPath:", resp);
        if (resp.GetMetaFromSharedPath?.status !== 0 || !resp.GetMetaFromSharedPath.meta) {
            throw new Error(`Failed to get item at path }`);
        }

            const meta_obj = resp.GetMetaFromSharedPath.meta;
        // let trimmedPath = path.endsWith("/") ? path.slice(0, -1) : path;
        // const parentPath = trimmedPath.substring(0, trimmedPath.lastIndexOf("/"));
        if (meta_obj.fileMeta) {
            // console.log("File meta found:", meta_obj.fileMeta);
            let size = 0;
            let file_obj = meta_obj.fileMeta;
            const versions = file_obj?.versions ?? [];
            const sizes = file_obj?.sizes ?? [];
            const versionIndex = versions.findIndex((v: Uint8Array) => {
                const curr = file_obj?.currentVersion ?? new Uint8Array();
                if (v.length !== curr.length) return false;
                for (let i = 0; i < v.length; i++) {
                    if (v[i] !== curr[i]) return false;
                }
                return true;
            });
            if (versionIndex !== -1 && sizes[versionIndex] !== undefined) {
                const val = sizes[versionIndex];
                size = typeof val === "number" ? val : val.toNumber();
            } else {
                throw new Error("Could not determine file size for the specified version.");
            }
            let file = new File();
            file.setFileUuid(file_obj.uuid ?? new Uint8Array());
            file.setParentPath(path);
            file.setFileName(file_obj.name ?? "");
            file.setNew(false);
            file.setSize(size);
            file.setVersionUuid(file_obj.currentVersion ?? new Uint8Array());
            file.setVersions(versions);
            file.setCurrentVersion(file_obj.currentVersion ?? new Uint8Array());
            file.setParentPath("shared/");
            file.setCreationDate(
                typeof file_obj.creationDate === "number"
                    ? file_obj.creationDate
                    : file_obj.creationDate
                        ? file_obj.creationDate.toNumber()
                        : 0
            );
            file.setLastModifiedDate(typeof file_obj.lastModifiedDate === "number"
                ? file_obj.lastModifiedDate
                : file_obj.lastModifiedDate
                    ? file_obj.lastModifiedDate.toNumber()
                    : 0
            );
            file.setSizes(sizes.map((s) => typeof s === "number" ? s : s.toNumber()));
            file.setOwner(file_obj.owner ??"");
            // console.log("Returning file:", file);

            return file;

        } else if (meta_obj.folderMeta) {
            let folder = new Folder();
            folder.setUuId(meta_obj.folderMeta.uuid ?? new Uint8Array());
            folder.setFolderName(meta_obj.folderMeta.name ?? "");
            folder.setParentPath("shared/");
            folder.setCreationDate(
                typeof meta_obj.folderMeta.creationDate === "number"
                    ? meta_obj.folderMeta.creationDate
                    : meta_obj.folderMeta.creationDate
                        ? meta_obj.folderMeta.creationDate.toNumber()
                        : 0
            );
            folder.setCurrentPage(-1);
            folder.setOrderBy(0);
            folder.setOwner(meta_obj.folderMeta.owner ?? "");
            folder.setLastModifiedDate(
                typeof meta_obj.folderMeta.lastModifiedDate === "number"
                    ? meta_obj.folderMeta.lastModifiedDate
                    : meta_obj.folderMeta.lastModifiedDate
                        ? meta_obj.folderMeta.lastModifiedDate.toNumber()
                        : 0
            );
            return folder;
        }
        else {
            throw new Error(`Item at path ${path} is neither a file nor a folder.`);
        }



    }
    static async getItem(path: string, trashed: boolean): Promise<File | Folder> {
        // console.log(`Getting item at path: ${path}, trashed: ${trashed}`);
        let pool = await getConnectionPool();
        let req = request.Request.create({
            id: null,
            reqCreateTime: Date.now(),
            getMetaFromPath: request.GetMetaFromPath.create({
                trashed,
                path,
                typeOfPath:0
            })
        });
        let resp = await pool.sendAndWait(req);
        console.log("response",resp);
        checkMigrate(resp.getMetaFromPath.status)
        if (resp.getMetaFromPath?.status !== 0 || !resp.getMetaFromPath.meta) {
            throw new Error(`Failed to get item at path }`);
        }
        // remove trailing slash if exists
        const meta_obj = resp.getMetaFromPath.meta;
        let trimmedPath = path.endsWith("/") ? path.slice(0, -1) : path;
        const parentPath = trimmedPath.substring(0, trimmedPath.lastIndexOf("/"));
        if (meta_obj.fileMeta) {
            let size = 0;
            let file_obj = meta_obj.fileMeta;
            const versions = file_obj?.versions ?? [];
            const sizes = file_obj?.sizes ?? [];
            const versionIndex = versions.findIndex((v: Uint8Array) => {
                const curr = file_obj?.currentVersion ?? new Uint8Array();
                if (v.length !== curr.length) return false;
                for (let i = 0; i < v.length; i++) {
                    if (v[i] !== curr[i]) return false;
                }
                return true;
            });
            if (versionIndex !== -1 && sizes[versionIndex] !== undefined) {
                const val = sizes[versionIndex];
                size = typeof val === "number" ? val : val.toNumber();
            } else {
                throw new Error("Could not determine file size for the specified version.");
            }
            console.log("File tags",file_obj.tags);
            console.log("file type",file_obj.fileType);
            let file = new File();
            file.setFileUuid(file_obj.uuid ?? new Uint8Array());
            file.setParentPath(path);
            file.setFileName(file_obj.name ?? "");
            file.setNew(false);
            file.setSize(size);
            file.setVersionUuid(file_obj.currentVersion ?? new Uint8Array());
            file.setVersions(versions);
            file.setCurrentVersion(file_obj.currentVersion ?? new Uint8Array());
            file.setParentPath(parentPath);
            file.setCreationDate(
                typeof file_obj.creationDate === "number"
                    ? file_obj.creationDate
                    : file_obj.creationDate
                        ? file_obj.creationDate.toNumber()
                        : 0
            );
            file.setFileType(file_obj.fileType ?? "");
            file.setTags(file_obj.tags ?? []);
            file.setLastModifiedDate(typeof file_obj.lastModifiedDate === "number"
                ? file_obj.lastModifiedDate
                : file_obj.lastModifiedDate
                    ? file_obj.lastModifiedDate.toNumber()
                    : 0
            );
            file.setSizes(sizes.map((s) => typeof s === "number" ? s : s.toNumber()));
            file.setOwner(file_obj.owner ??"");

            return file;

        } else if (meta_obj.folderMeta) {
            let folder = new Folder();
            folder.setUuId(meta_obj.folderMeta.uuid ?? new Uint8Array());
            folder.setFolderName(meta_obj.folderMeta.name ?? "");
            folder.setParentPath(parentPath);
            folder.setCreationDate(
                typeof meta_obj.folderMeta.creationDate === "number"
                    ? meta_obj.folderMeta.creationDate
                    : meta_obj.folderMeta.creationDate
                        ? meta_obj.folderMeta.creationDate.toNumber()
                        : 0
            );
            folder.setCurrentPage(-1);
            folder.setOrderBy(0);
            folder.setOwner(meta_obj.folderMeta.owner ?? "");
            folder.setLastModifiedDate(
                typeof meta_obj.folderMeta.lastModifiedDate === "number"
                    ? meta_obj.folderMeta.lastModifiedDate
                    : meta_obj.folderMeta.lastModifiedDate
                        ? meta_obj.folderMeta.lastModifiedDate.toNumber()
                        : 0
            );
            return folder;
        }
        else {
            throw new Error(`Item at path ${path} is neither a file nor a folder.`);
        }

    }
};
